<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>📅 Planifier un RDV</h3>
        <button @click="closeModal" class="close-btn">×</button>
      </div>

      <div class="modal-body">
        <div v-if="prospect" class="client-info">
          <h4>{{ prospect.client.nom }} {{ prospect.client.prenom }}</h4>
          <p>{{ prospect.typeIntervention }} - {{ prospect.priorite }}</p>
        </div>

        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>Date *</label>
            <input v-model="form.dateRdv" type="date" required class="form-control">
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>Début *</label>
              <input v-model="form.heureDebut" type="time" required class="form-control">
            </div>
            <div class="form-group">
              <label>Fin *</label>
              <input v-model="form.heureFin" type="time" required class="form-control">
            </div>
          </div>

          <div class="form-group">
            <label>Technicien *</label>
            <select v-model="form.technicien" required class="form-control">
              <option value="">Sélectionner...</option>
              <option v-for="tech in technicians" :key="tech._id" :value="tech._id">
                {{ tech.nom }} {{ tech.prenom }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Instructions</label>
            <textarea v-model="form.instructions" class="form-control"></textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button @click="closeModal" class="btn btn-secondary">Annuler</button>
        <button @click="submitForm" class="btn btn-primary" :disabled="!isFormValid">
          Planifier
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'CreateRdvModal',
  props: ['prospect'],
  emits: ['close', 'rdv-created'],
  setup(props, { emit }) {
    const technicians = ref([])
    const form = ref({
      dateRdv: '',
      heureDebut: '09:00',
      heureFin: '12:00',
      technicien: '',
      instructions: ''
    })

    const isFormValid = computed(() => {
      return form.value.dateRdv && form.value.heureDebut && 
             form.value.heureFin && form.value.technicien
    })

    const loadTechnicians = async () => {
      // Simulation
      technicians.value = [
        { _id: '1', nom: 'Martin', prenom: 'Paul' },
        { _id: '2', nom: 'Durand', prenom: 'Pierre' }
      ]
    }

    const submitForm = async () => {
      if (!isFormValid.value) return
      
      console.log('Créer RDV:', { prospect: props.prospect._id, ...form.value })
      emit('rdv-created', { prospect: props.prospect, ...form.value })
    }

    const closeModal = () => emit('close')

    onMounted(loadTechnicians)

    return { form, technicians, isFormValid, submitForm, closeModal }
  }
}
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-content { background: white; border-radius: 8px; width: 90%; max-width: 600px; max-height: 80vh; overflow-y: auto; }
.modal-header { padding: 1rem; background: var(--primary-blue); color: white; display: flex; justify-content: space-between; align-items: center; }
.close-btn { background: none; border: none; color: white; font-size: 1.5rem; cursor: pointer; }
.modal-body { padding: 1.5rem; }
.client-info { background: #f8f9fa; padding: 1rem; border-radius: 6px; margin-bottom: 1rem; }
.form-group { margin-bottom: 1rem; }
.form-row { display: flex; gap: 1rem; }
.form-group label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
.form-control { width: 100%; padding: 0.5rem; border: 1px solid #ddd; border-radius: 4px; }
.modal-footer { padding: 1rem; display: flex; justify-content: flex-end; gap: 0.5rem; border-top: 1px solid #eee; }
.btn { padding: 0.5rem 1rem; border: none; border-radius: 4px; cursor: pointer; }
.btn-primary { background: var(--primary-blue); color: white; }
.btn-secondary { background: #6c757d; color: white; }

/* ========== RESPONSIVE MOBILE ========== */
@media (max-width: 768px) {
  .modal-overlay { 
    padding: 0; 
    align-items: flex-end; 
  }
  
  .modal-content { 
    width: 100%; 
    max-width: 100%; 
    max-height: 95vh; 
    border-radius: 16px 16px 0 0; 
  }
  
  .modal-header { 
    padding: 1rem; 
    border-radius: 16px 16px 0 0; 
  }
  
  .modal-header h3 { font-size: 1.1rem; }
  
  .modal-body { padding: 1rem; }
  
  .client-info { 
    padding: 0.875rem; 
    margin-bottom: 0.875rem; 
  }
  
  .client-info h4 { font-size: 1rem; }
  .client-info p { font-size: 0.85rem; }
  
  .form-row { 
    flex-direction: column; 
    gap: 0; 
  }
  
  .form-group { margin-bottom: 0.875rem; }
  
  .form-control { 
    padding: 0.75rem; 
    font-size: 16px; /* Évite le zoom sur iOS */
  }
  
  .modal-footer { 
    padding: 1rem; 
    flex-direction: column; 
    gap: 0.5rem; 
  }
  
  .btn { 
    width: 100%; 
    padding: 0.875rem; 
    font-size: 1rem; 
  }
}

@media (max-width: 480px) {
  .modal-content { 
    max-height: 100vh; 
    border-radius: 0; 
  }
  
  .modal-header { 
    padding: 0.875rem; 
    border-radius: 0; 
  }
  
  .modal-body { padding: 0.875rem; }
  
  .modal-footer { padding: 0.875rem; }
}
</style>
